import { capitalizeFirst } from "@/shared/text/capitalizeFirst";

/** A raw status or probe token as display text, underscores as spaces and the first letter capitalized: "unhealthy" -> "Unhealthy", "assume_role" -> "Assume role". */
export function formatHealthToken(token: string): string {
  return capitalizeFirst(token.replace(/_/g, " "));
}

/** Canonical order the probes run in, so the dialog lists them in a stable, meaningful sequence. */
export const PROBE_ORDER = [
  "assume_role",
  "location",
  "list",
  "put",
  "get",
  "delete",
] as const;
